/*
 * HomePage
 */

import React from 'react';

// Material Resources

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../../NotFoundPage';
import CurrencyList from '../../../components/Models/Currency/CurrencyList';
import CurrencyEdit from '../../../components/Models/Currency/CurrencyCreateEdit/edit';
import CurrencyForm from '../../../components/Models/Currency/CurrencyForm';

function CurrencyPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={CurrencyList} />
      <Route path={`${path}/crear`} component={CurrencyForm} />
      <Route path={`${path}/:id`} component={CurrencyEdit} />
      <Route path="" component={NotFound} />
    </Switch>
  );
}

CurrencyPage.propTypes = {};

export default CurrencyPage;
